import { Directive, ElementRef, OnInit , Input } from '@angular/core';
import { PermissionService } from '../core/services/permission.service';
import { ProfilePermissionsNumberEnum } from '../core/models/profile.models';
 
@Directive({
    selector: '[hideIfUnauthorized]'
})
export class HideUnauthorizedDirective implements OnInit {
    @Input('hideIfUnauthorized') permission: any; // Required permission passed in
 
    constructor(private el: ElementRef, private permissionService: PermissionService) { }
 
    ngOnInit() {
        if (!this.permissionService.hasPermission(this.permission)) {
            this.el.nativeElement.style.display = 'none';
        }
    }
}